import {createGlobalStyle, css} from "styled-components"

export const MarkdownStyles = createGlobalStyle`
  ${({theme}) => css`
    .reward-wallet__white--markdown p,
    .reward-wallet__white--markdown span,
    .reward-wallet__white--markdown strong,
    .reward-wallet__white--markdown b,
    .reward-wallet__white--markdown i,
    .reward-wallet__white--markdown em,
    .reward-wallet__white--markdown h1,
    .reward-wallet__white--markdown h2,
    .reward-wallet__white--markdown h3,
    .reward-wallet__white--markdown h4,
    .reward-wallet__white--markdown h5,
    .reward-wallet__white--markdown h6 {
      color: ${theme.colors.greys.white};
    }
  `}
`
